module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/Precipitation/Kanagawa_Precipitation_MRI_RCP85_End.png";